import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isoWeek from 'dayjs/plugin/isoWeek';
import isBetween from 'dayjs/plugin/isBetween'; // Import the weekday plugin
import weekday from 'dayjs/plugin/weekday'; // Import the weekday plugin

// Extend the dayJS library to make the week start date as 'Monday'
dayjs.extend(updateLocale)
dayjs.extend(customParseFormat)
dayjs.updateLocale('en', {
    weekStart: 1,
})
dayjs.extend(weekday); // Extend dayjs with weekday plugin
dayjs.extend(isoWeek);
dayjs.extend(isBetween); // Extend dayjs with isBetween plugin

export { isoWeek as _ISO_WEEK_DAYJS }
export { isBetween as _IS_BETWEEN_DAYJS }
export { weekday as _WEEKDAY_DAYJS }
export { dayjs as _DAYJS }

export default function configureDayjs() {
    return dayjs
}